import MovimientoBancarioService from "@/services/bancos/MovimientoBancarioService";



const movimientos = (context, params) => {
  return MovimientoBancarioService.fetch(params)
    .then(res => {
      context.commit('MOVIMIENTOS', res.data);
    });
};



export default {
  movimientos,
};